import { Injectable } from '@angular/core';
import { ProfileNotificationDto } from './dto/profile-notification.dto';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileNotificationService {
  constructor(private _apiService: ProfileServiceApiService) {}

  public getProfileNotifications(profileId: number): Promise<Array<ProfileNotificationDto>> {
    return this._apiService.get(`profile/v2/${profileId}/notifications`);
  }
}
